import React, { Component } from "react";
import { connect } from "react-redux";
import authSelector from "../../../selectors/authSelector";
import StudentCreditPage from "../../student/StudentCreditPage";
import SchoolCreditPage from "../../school/SchoolCreditPage";
import TeacherCreditPage from "../../teacher/TeacherCreditPage";

/* eslint-disable no-alert, no-unreachable */
class Index extends Component {
  render() {
    const { userType } = this.props;
    switch (userType) {
      case "STUDENT":
        return <StudentCreditPage />;
        break;

      case "SCHOOL":
        return <SchoolCreditPage />;
        break;

      case "TEACHER":
        return <TeacherCreditPage />;
        break;

      default:
        return null;
        break;
    }
  }
}

export default connect(authSelector)(Index);



// WEBPACK FOOTER //
// ./src/components/common/credit/Index.js